<template>
  <v-container class="add-interface">
    <v-layout wrap>
      <v-card
        class="add-interface__card"
        v-for="(recipe, i) in recipes"
        :key="i"
      >
        <v-card class="add-interface__header">
          <apio-icon name="ui-new-window" lightModeColour="apioshade4" darkModeColour="apioshade4" size="32" />
          <span>{{ recipe.title }}</span>
        </v-card>
        <div class="add-interface__body">
          <v-card-text class="px-0">
            <div>{{ recipe.description }}</div>
          </v-card-text>
          <v-card-text class="d-flex px-0">
            <div
              class="mr-2"
              v-for="(step, ii) in recipe.steps"
              :key="ii"
              :title="step"
            >
              <img
                height="32"
                :src="'/img/icons/' + step + '.svg'"
                :alt="step"
              />
            </div>
            <div class="mr-2" v-if="!recipe.steps">No steps defined.</div>
          </v-card-text>
          <apio-button button-size="medium" @click="add(recipe)"
            >Use this recipe

            <apio-icon class="ml-2" name="chevron-right" lightModeColour="white" darkModeColour="white" size="16" />
            </apio-button
          >
        </div>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import request from '@/API/';

export default {
  name: "AddInterface",
  props: {
    parent: {
      type: String,
      default: "",
    },
  },
  created() {
    request
      .get("/editor/recipes")
      .then((res) => {
        this.recipes = res.data;
      })
      .catch((err) => {
        console.log("Error getting recipes", err);
      });
  },
  data() {
    return {
      recipes: [],
      loading: false,
    };
  },
  methods: {
    add(sel) {
      this.$emit("recipeadd", { recipe: sel, parent: this.parent });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-interface {
  color: var(--apio-shade-2);
  &__card {
    margin-bottom: 32px;
    width: 292px;
    border: 1px solid var(--apio-shade-4);
    border-radius: 4px;

    @media screen and (max-width: 1024px) {
      width: 320px;
    }
  }

  &__card:not(last-child) {
    margin-right: 32px;
  }

  &__body {
    padding: 16px 16px 24px 16px;
  }

  &__header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    background-image: url("/img/misc/small-apio-bg.png");
    background-size: cover;
    color: white;
    font-size: var(--font-h2-size);
    font-weight: var(--font-semi-bold);
    padding: 8px;
    height: 132px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.screenshot {
  width: 300px;
  height: 312px;
  overflow: hidden;
}
</style>
